var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { action } from "mobx";
import { SHOULD_LOG } from "../env";
import { replaceContents } from "./array.utils";
import { equalByJsonSnapshot } from "./equality.utils";
import { reportError } from "./errors.utils";
import { uniq } from "./ramdaEquivalents.utils";
import { isArray, isObject, isString } from "./typeChecks.utils";
export function mergeIntoObjectByDescriptors(a, b, options) {
    var propertyDescriptorMap = Object.getOwnPropertyDescriptors(b);
    if (options) {
        if (options.configurable === true || options.configurable === false) {
            Object.values(propertyDescriptorMap).forEach(function (desc) { return desc.configurable = options.configurable; });
        }
    }
    Object.defineProperties(a, propertyDescriptorMap);
    return a;
}
export function getValueOfKey(key, object) {
    return object ? object[key] : undefined;
}
export var setValueOfKey = function (object, key, newValue) {
    object[key] = newValue;
};
export function recursiveMergeWithTypeCast(obj, _src, schema, skipUnknownKeys) {
    if (schema === void 0) { schema = {}; }
    if (skipUnknownKeys === void 0) { skipUnknownKeys = true; }
    var objIsValid = obj instanceof Object && !isArray(obj) && Boolean(obj);
    if (!objIsValid) {
        SHOULD_LOG() && console.warn('The object supplied for recursiveMergeWithTypeCast is not an object, though this has been ignored and the application will attempt to proceed with merging.', obj);
    }
    var src = isString(_src) ? {} : _src;
    if (!src)
        return obj;
    var keys = skipUnknownKeys ? Object.keys(obj) : uniq(__spreadArray(__spreadArray([], Object.keys(obj), true), Object.keys(src), true));
    keys.forEach(function (key) {
        var _a;
        var setter = setValueOfKeyFactory(obj);
        if (src[key] !== undefined) {
            var typeofKey = schema[key] || typeof obj[key];
            switch (typeofKey) {
                case 'boolean':
                    setter(key, src[key] === null ? src[key] : !!src[key]);
                    break;
                case 'string':
                    setter(key, src[key] === null ? src[key] : src[key] + '');
                    break;
                case 'number':
                    setter(key, src[key] === null ? src[key] : parseFloat(src && src[key]));
                    break;
                default: {
                    if (isArray(obj[key])) {
                        replaceContents(obj[key], ((_a = src) !== null && _a !== void 0 ? _a : [])[key]);
                    }
                    else if (isObject(obj[key])) {
                        recursiveMergeWithTypeCast(obj[key], src[key], undefined, false);
                    }
                    else {
                        setter(key, src[key]);
                    }
                }
            }
        }
    });
    return obj;
}
export function copyWithJSON(obj) {
    if (obj === undefined || obj === null)
        return obj;
    return JSON.parse(JSON.stringify(obj));
}
export var mergeIntoObjectWithDescriptor = action(function (obj, src, options) {
    if (src === void 0) { src = {}; }
    if (!obj) {
        throw Error('mergeIntoObject requires there to be an object to merge into!');
    }
    var _a = (options || {}).mergeInPlace, mergeInPlace = _a === void 0 ? true : _a;
    var o = mergeInPlace ? obj : copyWithJSON(obj);
    for (var key in src) {
        try {
            var descriptor = Reflect.getOwnPropertyDescriptor(o, key);
            var isWritable = (descriptor === null || descriptor === void 0 ? void 0 : descriptor.writable) || (descriptor === null || descriptor === void 0 ? void 0 : descriptor.set);
            var hasChanged = !equalByJsonSnapshot(o[key], src[key]);
            if (isWritable && hasChanged) {
                // @ts-ignore
                o[key] = src[key];
            }
        }
        catch (e) {
            reportError(e);
            SHOULD_LOG() && console.error('An error occurred while merging objects.', e);
            SHOULD_LOG() && console.error('Error key: ', key);
        }
    }
    return o;
});
export var setValueOfKeyFactory = function (object) { return function (key, newValue) {
    object[key] = newValue;
}; };
export function convertKeyValuePairArrayToObject(array) {
    var result = {};
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var _a = array_1[_i], key = _a[0], value = _a[1];
        result[key] = value;
    }
    return result;
}
